export const VIDEO_ID = 1;
export const NARRATIVE_ID = 2;
export const QUIZ_ID = 4;
export const FILE_SUBMISSION_ID = 5;
export const INTERACTIVE_ID = 10;

export const subQuestTypes = [
  { label: 'Video', value: VIDEO_ID },
  { label: 'Narrative', value: NARRATIVE_ID },
  { label: 'Quiz', value: QUIZ_ID },
  { label: 'File Submission', value: FILE_SUBMISSION_ID },
  { label: 'Interactive', value: INTERACTIVE_ID },
];
